import {Card, Container, Row, Col, Spinner, Form, Button} from "react-bootstrap";
import React, {useState, useEffect} from "react";
import {ROUTES} from "../routes";
import {useAuth} from "../components/auth/AuthProvider";
import {getMachinesReport} from "../lib/api/getMachinesReport";
import {getActiveErrors} from "../lib/api/getActiveErrors";
import {getMachinesWithActiveErrors} from "../lib/api/getMachinesWithActiveErrors";
import {MachinesStatusList} from "../components/generic/machines/MachinesStatusList";

export const MachinesReportPage = () => {
    /* *************************************************************************** Report page elements ********/

    const [provisionedMachinesCount, setProvisionedMachinesCount] = useState(null);
    const [connectedMachinesCount, setConnectedMachinesCount] = useState(null);
    const [firmwareVersions, setFirmwareVersions] = useState(null);
    const [mediaVersions, setMediaVersions] = useState(null);
    const [activeErrors, setActiveErrors] = useState(null);
    const [selectedErrors, setSelectedErrors] = useState(new Set());

    const {token} = useAuth();

    useEffect( () => {

        getMachinesReport(token).then( (data) => {
            setProvisionedMachinesCount(data["provisionedMachinesCount"]);
            setConnectedMachinesCount(data["connectedMachinesCount"]);

            setFirmwareVersions(data["installedFirmwareVersions"]);
            setMediaVersions(data["installedMediaVersions"]);
        });

        getActiveErrors(token).then( (data) => {
            setActiveErrors(data);
        })
    }, [token]);

    const handleErrorCheckboxChange = (errorCode) => {
        setSelectedErrors(prev => {
            const newSet = new Set(prev);
            if (newSet.has(errorCode)) {
                newSet.delete(errorCode);
            } else {
                newSet.add(errorCode);
            }
            return newSet;
        });
    };

    const searchByErrorsClicked = () => {
        _doLoadMachinesWithActiveErrors(null)

    };

    /* ************************************************************** Machines with selected active errors ********/

    //////////// search machines with selected errors
    const [machinesWithErrors_showModal, setMachinesWithErrors_showModal] = useState(false);
    const [machinesWithErrors_isLoading, setMachinesWithErrors_isLoading] = useState(false);
    const [machinesWithErrors_data, setMachinesWithErrors_data] = useState([]);
    const [machinesWithErrors_lastEvaluatedKey, setMachinesWithErrors_lastEvaluatedKey] = useState(null);

    // reset elements
    const _resetMachinesWithErrors = () => {
        setMachinesWithErrors_isLoading(false);
        setMachinesWithErrors_lastEvaluatedKey(null);
        setMachinesWithErrors_data([]);
    }

    const machinesWithErrors_onLoadData = () => {
        if (machinesWithErrors_lastEvaluatedKey !== null) {
            console.log(">> load more data from key");
            console.log(machinesWithErrors_lastEvaluatedKey);
            console.log("<<");

            _doLoadMachinesWithActiveErrors(machinesWithErrors_lastEvaluatedKey);
        }
    }

    const _doLoadMachinesWithActiveErrors = (from_exclusive_start_key) => {

        // build errors mask
        const errors = Array.from(selectedErrors)

        setMachinesWithErrors_isLoading(true);

        // call load API
        getMachinesWithActiveErrors(token, errors, from_exclusive_start_key).then( (data) => {               // TODO remove count and add time limit
            /* will get:
                {
                    "machines": [ ... ],
                    "last_evaluated_key": { ... }
                }
             */
            setMachinesWithErrors_data(machinesWithErrors_data.concat(data.machines));
            setMachinesWithErrors_lastEvaluatedKey( data.last_evaluated_key || null)

            setMachinesWithErrors_showModal(true);
            setMachinesWithErrors_isLoading(false);
        });
    }

    const machineWithErrors_onCloseModal = () => {
        setMachinesWithErrors_showModal(false);
        _resetMachinesWithErrors();
    };

    return (
        <Container >
            <MachinesStatusList show={machinesWithErrors_showModal}
                                data={machinesWithErrors_data}
                                isLoading={machinesWithErrors_isLoading}
                                lastEvaluatedKey={machinesWithErrors_lastEvaluatedKey}
                                onCloseHandler={machineWithErrors_onCloseModal}
                                loadMoreHandler={machinesWithErrors_onLoadData}
                                title={"Machines with selected errors"}
            />


            <Card className="border-primary mb-4">
                <Card.Header as="h5">Machines Summary</Card.Header>
                <Card.Body>
                    <Row className="mb-2">
                        <Col>
                            <a href={ROUTES.MACHINES}>&lt;-- Back</a>
                        </Col>
                    </Row>
                    <Row className="mb-2">
                        <Col md={4} className="d-flex">
                            <Card className="border-primary mb-4 w-100">
                                <Card.Header as="h5">Count</Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col>Provisioned Machines</Col>
                                        <Col>{provisionedMachinesCount} {provisionedMachinesCount === null && <Spinner animation="border" size="sm" />}</Col>
                                    </Row>
                                    <Row>
                                        <Col>Connected Machines</Col>
                                        <Col>{connectedMachinesCount} {connectedMachinesCount === null && <Spinner animation="border" size="sm" />}</Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col md={4} className="d-flex">
                            <Card className="border-primary mb-4 w-100">
                                <Card.Header as="h5">Active errors</Card.Header>
                                <Card.Body>
                                    {activeErrors === null && <Spinner animation="border" size="sm" />}
                                    { activeErrors !== null && Object.keys(activeErrors).includes("error_mask_1") &&
                                        <>
                                        {Object.keys(activeErrors["error_mask_1"]).map((v) => {
                                            const elm = activeErrors["error_mask_1"][v];
                                            const bit = elm["bit"];
                                            return (
                                                <Row key={bit} className="mb-1">
                                                    <Col style={{flex: "0 0 10%", maxWidth: "10%"}}>
                                                        <Form.Check
                                                            type="checkbox"
                                                            checked={selectedErrors.has(bit)}
                                                            onChange={() => handleErrorCheckboxChange(bit)}
                                                        />
                                                    </Col>
                                                    <Col style={{flex: "0 0 70%", maxWidth: "70%"}}><b>{elm["name"]}</b></Col>
                                                    <Col style={{flex: "0 0 20%", maxWidth: "20%"}}>{elm["count"]}</Col>
                                                </Row>
                                            )
                                        })}
                                        <Row className="mt-3">
                                            <Col>
                                                <Button
                                                    variant="primary"
                                                    size="sm"
                                                    onClick={searchByErrorsClicked}
                                                    disabled={selectedErrors.size === 0 || machinesWithErrors_isLoading}
                                                >
                                                    { machinesWithErrors_isLoading ? (
                                                        <>
                                                            <Spinner size="sm" animation="border" className="me-2" />
                                                            Loading...
                                                        </>
                                                    ) : (
                                                        'Search by Selected Errors'
                                                    )}

                                                </Button>
                                            </Col>
                                        </Row>
                                        </>
                                    }

                                </Card.Body>
                            </Card>
                        </Col>

                        <Col md={4} className="d-flex">
                            <Card className="border-primary mb-4 w-100">
                                <Card.Header as="h5">Firmware versions</Card.Header>
                                <Card.Body>
                                    {!firmwareVersions && <Spinner animation="border" size="sm" />}
                                    { firmwareVersions &&
                                        firmwareVersions.map((v, i) => {
                                            return (
                                                <Row>
                                                    <Col><b>{v["version"]}</b></Col>
                                                    <Col>{v["count"]}</Col>
                                                </Row>
                                            )
                                        })
                                    }

                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4} className="d-flex">
                            <Card className="border-primary mb-4 w-100">
                                <Card.Header as="h5">Media versions</Card.Header>

                                <Card.Body>
                                    {!mediaVersions && <Spinner animation="border" size="sm" />}
                                    { mediaVersions &&
                                        mediaVersions.map((v, i) => {
                                            return (
                                                <Row>
                                                    <Col><b>{v["version"]}</b></Col>
                                                    <Col>{v["count"]}</Col>
                                                </Row>
                                            )
                                        })
                                    }
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>
                </Card.Body>
            </Card>

        </Container>
    );
};